const webpackRequireContext = require.context(
  "!raw-loader!../fixtures",
  false,
  /\.md$/
);

// Convert to Map
export const fixtures = webpackRequireContext.keys().reduce((map, fileName) => {
  const markdown = webpackRequireContext(fileName);
  // remove the leading './'
  if (fileName.startsWith("./")) {
    fileName = fileName.substr(2);
  }

  return map.set(fileName, markdown);
}, new Map());


